import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from "react";
import { handleTokenAndPostRequest } from "../utils/utils";

const ViewScopeContext = createContext();

export function ViewScopeProvider({ children }) {
  const [viewScope, setViewScopeRaw] = useState(() => localStorage.getItem("vl_viewScope") || "mine");
  const [agentFilter, setAgentFilterRaw] = useState(() => localStorage.getItem("vl_agentFilter") || null);
  const [team, setTeam] = useState([]);
  const [mySlug, setMySlug] = useState("");
  const [agencyId, setAgencyId] = useState("");
  const [teamLoading, setTeamLoading] = useState(true);

  // Persist to localStorage
  const setViewScope = useCallback((v) => {
    setViewScopeRaw(v);
    localStorage.setItem("vl_viewScope", v);
  }, []);

  const setAgentFilter = useCallback((v) => {
    setAgentFilterRaw(v);
    if (v) localStorage.setItem("vl_agentFilter", v);
    else localStorage.removeItem("vl_agentFilter");
  }, []);

  // Fetch team once
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await handleTokenAndPostRequest(
          `${window.api_host}/get-agency-team`,
          {}
        );
        if (!cancelled && res.data && res.data.status === "success") {
          setTeam(res.data.team || []);
          setMySlug(res.data.my_slug || "");
          setAgencyId(res.data.agency_id || "");
        }
      } catch (e) {
        console.error("Failed to fetch agency team:", e);
      }
      if (!cancelled) setTeamLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <ViewScopeContext.Provider value={{
      viewScope, setViewScope,
      agentFilter, setAgentFilter,
      team, mySlug, agencyId, teamLoading,
    }}>
      {children}
    </ViewScopeContext.Provider>
  );
}

export function useViewScope() {
  return useContext(ViewScopeContext);
}
